import { motion } from "framer-motion";
import { Gauge, Search, ShieldCheck } from "lucide-react";
import { CodeRainAmbience } from "./Ambience";

const points = [
  {
    icon: Gauge,
    title: "Rapide",
    text: "Chaque page s'affiche en un instant. Vos visiteurs restent, Google vous récompense.",
  },
  {
    icon: Search,
    title: "Trouvable",
    text: "Structure pensée pour le référencement local : on vous cherche, on vous trouve.",
  },
  {
    icon: ShieldCheck,
    title: "Durable",
    text: "Hébergement fiable, sécurisé, sauvegardé. Une base solide qui tient dans le temps.",
  },
];

export default function Stack() {
  return (
    <section
      data-testid="stack-section"
      className="relative overflow-hidden py-28 sm:py-40 px-5 sm:px-8 lg:px-12 border-t border-white/[0.06]"
    >
      <CodeRainAmbience />
      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-7">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500 mb-6 block">
            (07) — Sous le capot
          </span>
          <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tighter">
            La technique reste <span className="text-outline">invisible</span>. Les résultats, non.
          </h2>
        </div>
        <p className="lg:col-span-4 lg:col-start-9 text-zinc-400 leading-relaxed">
          Sous le capot, ML utilise les mêmes technologies que les plus belles marques du web. Vous n'avez rien à gérer : vous profitez d'un site rapide, bien référencé et sécurisé — le reste, c'est notre métier.
        </p>
      </div>

      <div className="relative z-10 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/[0.06] border border-white/[0.06] rounded-2xl overflow-hidden mt-14">
        {points.map((p, i) => {
          const Icon = p.icon;
          return (
            <motion.div
              key={p.title}
              data-testid={`stack-item-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.06, duration: 0.5 }}
              className="bg-[var(--bg-soft)] p-8 sm:p-10 hover:bg-[#0d0d0d] transition-colors duration-500"
            >
              <Icon className="w-7 h-7 text-[var(--accent)] mb-6" strokeWidth={1.4} />
              <h3 className="font-display text-2xl tracking-tight mb-3">{p.title}</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">{p.text}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
